module.exports = __webpack_public_path__ + "static/img-our-vision-67f9521014587bd90bf1d0a8f30ef651.jpg";